import React, { Component } from 'react'
import parse from 'html-react-parser'

class FeatureHighlights extends Component {
  
  render() {

    let { image, title, content } = this.props

    return (
      <section className='feature-highlights'>
        <div className='feature-highlights__inner'>
          <div className='feature-highlights__image'>
            <picture>
              <img src={image.sourceUrl} alt={title} />
            </picture>
          </div>
          <div className='feature-highlights__content'>
            { title && <h2 className='feature-highlights__title'>{title}</h2> }
            { content &&
              <div className='feature-highlights__text'>
                {parse(content)}
              </div>
            }
          </div>
        </div>
      </section>
    )
  }
}

export default FeatureHighlights
